"use client"

import { Box, Heading, Text, Progress } from "@chakra-ui/react"

export default function LoadingScreen() {
    return (
        <Box
            position="fixed"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bg="white"
            zIndex="9999"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Box className="animate-pulse" mb={8}>
                <Heading
                    as="h1"
                    fontSize="3xl"
                    fontWeight="bold"
                    bgGradient="linear(to-r, indigo.500, purple.500, cyan.500)"
                    bgClip="text"
                >
                    Indiahirings
                </Heading>
            </Box>
            <Box w="200px" mb={8}>
                <Progress size="xs" colorScheme="indigo" isIndeterminate borderRadius="full" className="animate-shimmer" />
            </Box>
            <Text color="gray.500">IndiaHirings...</Text>
        </Box>
    )
}
